export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11280.aa08fb57.jpg";